import { createStore } from 'vuex';

// module
import auth, { type AuthModule } from './modules/auth';
import i18n, { type I18nModule } from './modules/i18n';
import nav, { type NavModule } from './modules/nav';
import misc, { type MiscModule } from './modules/misc';
import siteSettings, { type SiteSettingsModule } from './modules/site-settings';
import other, { type OtherModule } from './modules/other';
import dashboards, { type DashboardsModule } from './modules/dashboards';
import reports, { type ReportsModule } from './modules/reports';
import session, { type SessionModule }  from './modules/session';
import crm, { type CrmModule } from './modules/crm';
import affiliate, { type AffiliateModule } from './modules/affiliate';
import type { TypedStoreBaseFromCombinedModule } from '@/types/vuex';
import type { DeepMergeArray } from '@/types/util';

const debug = process.env.NODE_ENV !== 'production';

const storeConfig = {
  modules: {
    auth,
    i18n,
    nav,
    misc,
    siteSettings,
    other,
    dashboards,
    reports,
    session,
    crm,
    affiliate,
  },
  strict: debug,
}

// невозможно сократить без Circular Reference Error, Omit не помогает
export type RootState = {
  'dashboards': DashboardsModule['state'],
  'reports': ReportsModule['state'],
  'auth': AuthModule['state'],
  'session': SessionModule['state'],
  'nav': NavModule['state'],
  'other': OtherModule['state'],
  'misc': MiscModule['state'],
  'i18n': I18nModule['state'],
  'affiliate': AffiliateModule['state'],
  'crm': CrmModule['state'],
  'siteSettings': SiteSettingsModule['state']
};

type ModulesArray = [
  AuthModule,
  I18nModule,
  NavModule,
  MiscModule,
  SiteSettingsModule,
  OtherModule,
  DashboardsModule,
  ReportsModule,
  SessionModule,
  CrmModule,
  AffiliateModule
];

type TypedStore = Omit<typeof StoreInstance, 'getters' | 'commit' | 'dispatch'> 
  & TypedStoreBaseFromCombinedModule<DeepMergeArray<ModulesArray>>;

const StoreInstance = createStore<RootState>(storeConfig);

export function useTypedStore(): TypedStore {
  return StoreInstance;
}

export default StoreInstance;
